import { render, staticRenderFns } from "./MaterialTextArea.vue?vue&type=template&id=560490c6&scoped=true&"
import script from "./MaterialTextArea.vue?vue&type=script&lang=js&"
export * from "./MaterialTextArea.vue?vue&type=script&lang=js&"
import style0 from "./MaterialTextArea.vue?vue&type=style&index=0&id=560490c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560490c6",
  null
  
)

export default component.exports